module.exports = __webpack_public_path__ + "img/banner1.01e9aa04.png";